<script lang="ts">import Button from '../../Button/Button.svelte';
const { colorMode = undefined, disabled = false, altText = '', onClick = undefined, text = '', class: className = '', ...rest } = $props();
</script>

<Button
  {...rest}
  type="submit"
  class="SubmitButton {className}"
  variant="button"
  {colorMode}
  size="small"
  {disabled}
  {altText}
  {onClick}
  {text}
/>

<style>@layer design-system-components.pwds {
  :global(.SubmitButton.Button.Action--button.Action--small) {
    flex-shrink: 0;
  }
}</style>
